/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import PersonalDetails from "./PersonalDetails.container";

export default PersonalDetails;
